export const FILTER_MIN_WIDTH = 288;
export const FILTER_MAX_WIDTH = 1400;
export const HEADER_MIN_WIDTH = 400;

export function getFilterMaxWidth() {
  return Math.min(FILTER_MAX_WIDTH, Math.max(FILTER_MIN_WIDTH, window.innerWidth - HEADER_MIN_WIDTH));
}

export default {
  FILTER_MIN_WIDTH,
  FILTER_MAX_WIDTH,
  HEADER_MIN_WIDTH,
  getFilterMaxWidth,
};
